import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { ContextType, ErrorModalContext } from "@/ErrorHandling/ErrorModalContextProvider";
import * as React from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { parseError } from "./utils";

const ErrorModal: React.FC = () => {
  const [errorModalState, setErrorModalState] = useContext(ErrorModalContext) as ContextType;
  const { t } = useTranslation();

  if (!errorModalState.error) {
    return null;
  }

  const {
    msg,
    refetchable,
    error_title = t("general.Error"),
    cancel_button = t("general.Cancel"),
  } = parseError(errorModalState.error, t);
  return (
    <Dialog
      open={errorModalState.isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ minWidth: "400px" }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ minWidth: "400px" }}>
        {error_title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">{msg}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setErrorModalState({ ...errorModalState, isOpen: false })}>{cancel_button}</Button>
        {refetchable && <Button onClick={() => errorModalState.resend?.()}>Resend request</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
